/**
 * Chave de query (apenas desenvolvimento): força a UI da demo nesta secção sem alterar o Firestore.
 * Ex.: `?product_demo_preview=reminder_settings`
 */

import type { ProductDemoSpotlightPlacement } from '../utils/product-demo-spotlight-layout';

export const PRODUCT_DEMO_PREVIEW_QUERY_KEY = 'product_demo_preview';

/** Valor esperado para {@link PRODUCT_DEMO_PREVIEW_QUERY_KEY} nesta etapa. */
export const PRODUCT_DEMO_PREVIEW_VALUE_REMINDER_SETTINGS = 'reminder_settings';

/** Seletor CSS da secção “Periodicidade e horário” (atributo `data-product-demo-reminder-schedule` no JSX). */
export const PRODUCT_DEMO_REMINDER_SCHEDULE_SELECTOR = '[data-product-demo-reminder-schedule]';

/** Seletor CSS da secção “Testar envio” (WhatsApp). */
export const PRODUCT_DEMO_REMINDER_WHATSAPP_TEST_SELECTOR = '[data-product-demo-whatsapp-test]';

export const PRODUCT_DEMO_SESSION_WELCOME_KEY = 'retornaar:demo:reminder_settings:welcome_seen';

/** Spotlight da secção de teste de WhatsApp (antes da periodicidade). */
export const PRODUCT_DEMO_SESSION_WHATSAPP_SPOTLIGHT_KEY =
  'retornaar:demo:reminder_settings:whatsapp_spotlight_seen';

export const PRODUCT_DEMO_SESSION_SPOTLIGHT_KEY = 'retornaar:demo:reminder_settings:spotlight_seen';

/** Espaço entre o card do spotlight e a secção destacada. */
export const PRODUCT_DEMO_SPOTLIGHT_GAP_PX = 16;

/** Margem mínima do cartão em relação às bordas da viewport. */
export const PRODUCT_DEMO_SPOTLIGHT_VIEWPORT_PAD_PX = 16;

/**
 * Espera após {@link HTMLElement.scrollIntoView} (`behavior: smooth`) antes de revelar overlay + cartão,
 * quando `scrollend` não estiver disponível ou não disparar (ex.: Safari antigo).
 */
export const PRODUCT_DEMO_SPOTLIGHT_SCROLL_SETTLE_MS = 550;

/**
 * Onde posicionar o cartão do spotlight nesta secção (ajuste por tela para não cobrir o alvo).
 */
export const PRODUCT_DEMO_REMINDER_SETTINGS_SPOTLIGHT_PLACEMENT: ProductDemoSpotlightPlacement =
  'above';

/** Cartão do spotlight sobre “Testar envio” (bloco acima da periodicidade). */
export const PRODUCT_DEMO_REMINDER_WHATSAPP_SPOTLIGHT_PLACEMENT: ProductDemoSpotlightPlacement =
  'below';

export type { ProductDemoSpotlightPlacement };
